import { render, staticRenderFns } from "./leaveRequests.vue?vue&type=template&id=0f727d8f&"
import script from "./leaveRequests.vue?vue&type=script&lang=js&"
export * from "./leaveRequests.vue?vue&type=script&lang=js&"
import style0 from "./leaveRequests.vue?vue&type=style&index=0&id=0f727d8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports